import AddBoxIcon from '@mui/icons-material/AddBox';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import {
  MenuItem,
  Menu,
  Fade,
  Button,
  styled,
  Stack,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { isEmpty } from 'lodash-es';
import React, { FC, useState, MouseEvent, useEffect } from 'react';

import WsColors from '../../WsColors';
import WsTypography, { WsTypoVariants, WsTypoColors } from '../WsTypography/WsTypography';

interface IEmailList {
  emails: string[];
  handleProfileAction: (arg1: string, arg2: string | null) => void;
  main?: boolean;
}

const EmailButton = styled(Button)(() => ({
  color: WsColors.TheBlues500,
  borderColor: WsColors.TheBlues500,
  padding: 8,
  marginRight: '7px',
}));

const EmailList: FC<IEmailList> = ({ emails, handleProfileAction, main = false }) => {
  const uniqueContacts = Array.from(new Set(emails));
  const limit = 2;
  const hiddenContacts: string = '+' + String(uniqueContacts.length - limit) + ' More';
  const isContactMoreThenLimit = uniqueContacts.length > limit;
  const tempUniqueContacts = [...uniqueContacts];
  const minUniqueContacts = tempUniqueContacts.slice(0, limit);
  const [requestForMoreContact, setRequestForMoreContact] = useState<boolean>(false);
  const [emailsWithLimit, setEmailsWithLimit] = useState<string[]>([]);
  console.log(main);

  useEffect(() => {
    isEmpty(emailsWithLimit) && !isEmpty(emails) && setEmailsWithLimit(minUniqueContacts);
  }, [emails, emailsWithLimit, minUniqueContacts]);

  const increaseTheLimit = () => {
    setRequestForMoreContact(true);
    setEmailsWithLimit(uniqueContacts);
  };

  const decreaseTheLimit = () => {
    setRequestForMoreContact(false);
    setEmailsWithLimit(minUniqueContacts);
  };

  const addIcon = () => (
    <Button onClick={() => handleProfileAction('addEmail', null)}>
      <AddBoxIcon />
    </Button>
  );

  const MenuData: FC<{ email: string | null }> = ({ email }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    return (
      <>
        <EmailButton
          sx={{ mt: requestForMoreContact ? 1 : 0 }}
          onClick={handleClick}
          variant="text"
        >
          {email}
        </EmailButton>
        <Menu
          id="fade-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
          sx={{ zIndex: 2000 }}
        >
          <MenuItem onClick={() => handleProfileAction('mail', email)}>
            <ListItemIcon>
              <MailOutlineIcon key={0} fontSize="small" sx={{ color: WsColors.TheBlues500 }} />
            </ListItemIcon>
            <ListItemText sx={{ color: WsColors.TheBlues500 }}>Send Email</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => handleProfileAction('copy', email)}>
            <ListItemIcon>
              <ContentCopyIcon key={0} fontSize="small" sx={{ color: WsColors.TheBlues500 }} />
            </ListItemIcon>
            <ListItemText sx={{ color: WsColors.TheBlues500 }}>Copy</ListItemText>
          </MenuItem>
          {/* <MenuItem onClick={() => handleProfileAction('mailPrimary', email)}>
            Mark as Primary
          </MenuItem>
          {!main && (
            <MenuItem onClick={() => handleProfileAction('deleteEmail', email)}>Delete</MenuItem>
          )} */}
        </Menu>
      </>
    );
  };

  return (
    <>
      {emailsWithLimit.map((email: string, index: number) => (
        <React.Fragment key={index}>
          {!isEmpty(email) && (
            <>
              <MenuData key={index} email={email} />
              {index < emails.length - 1 && ', '}
            </>
          )}
        </React.Fragment>
      ))}
      {isEmpty(emailsWithLimit) && (
        <Stack direction="row" spacing={2}>
          <WsTypography variant={WsTypoVariants.BODY1} bold={true}>
            Not added
          </WsTypography>
          {addIcon()}
        </Stack>
      )}
      {!requestForMoreContact && isContactMoreThenLimit && (
        <WsTypography
          variant={WsTypoVariants.BODY2}
          color={WsTypoColors.PRIMARY}
          onClick={increaseTheLimit}
          cursor="pointer"
        >
          {hiddenContacts}
        </WsTypography>
      )}
      {requestForMoreContact && (
        <WsTypography
          variant={WsTypoVariants.BODY2}
          color={WsTypoColors.PRIMARY}
          cursor="pointer"
          onClick={decreaseTheLimit}
        >
          Hide
        </WsTypography>
      )}
    </>
  );
};

export default EmailList;
